export default __webpack_public_path__ + "static/media/gamepad_black.e7bbf5e3.svg";